// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (value: string) => /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i.test(value);
